import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {Constants as constants} from '../../../../config/constants';
import {saveSvgAsPng} from 'save-svg-as-png';
import {Cache as cache} from '../../../../config/cache';

@Component
export default class InitComponent extends Vue {
    public isContentHidden = true;

    public exportAsPNG() {
        saveSvgAsPng(document.getElementById(constants.svgId)!, 'diagram.png', {
            backgroundColor: constants.chartExportParams.background,
            scale: 2,
            left: cache.chartViewBox.x - constants.exportXSpacing,
            top: cache.chartViewBox.y,
            width: cache.chartViewBox.width + constants.exportXSpacing * 2,
            height: cache.chartViewBox.height
        });
    }

    public toggleMenu() {
        this.isContentHidden = !this.isContentHidden;
    }
}
